import { api } from '@api'
import {
  Contracts,
  ContractFilters,
  ContractsFilterResponse,
  ContractsAsnumsResponse,
} from '@types'

const base = '/sap-items'

interface GetContractsResponse {
  contracts: Contracts
}

type Params = {
  filters?: ContractFilters
}

const getContracts = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetContractsResponse>(base, {
    params: {
      ...filters,
    },
  })

  return response.data.contracts
}

const getContractsFilter = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsFilterResponse>(base + '/filters', {
    params: filters,
  })

  return response.data
}

const getAsnums = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsAsnumsResponse>(base + '/asnums', {
    params: filters,
  })

  return response.data
}

export const ContractsApi = { getContracts, getContractsFilter, getAsnums }
